module.exports = __webpack_public_path__ + "static/media/icon-backpack.f18c639b.svg";